import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=4cda5c3c&scoped=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&lang=js"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=4cda5c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda5c3c",
  null
  
)

export default component.exports